import gql from 'graphql-tag'
import { get } from 'lodash'

import IUser from '../types/IUser'
import { apolloClientPrivate } from '../../../graphql/apolloClient'
import { OrganisationRoleEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'

export interface IResponse {
  admin: {
    user: {
      patch: Pick<IUser, 'organisation_role'>
    }
  }
}

export interface IVariables {
  userId: number
  role: OrganisationRoleEnum
}

export type IOperationResult = Pick<IUser, 'organisation_role'>

export const CHANGE_USER_ROLE_MUTATION = gql`
  mutation changeUserRole($userId: PositiveInt!, $role: OrganisationRoleEnum!) {
    admin {
      user(id: $userId) {
        id
        patch(input: { organisation_role: $role }) {
          id
          organisation_role
        }
      }
    }
  }
`
/**
 * @deprecated
 */
export default async (variables: IVariables): Promise<IOperationResult> => {
  const response = await apolloClientPrivate.mutate<IResponse>({
    variables,
    mutation: CHANGE_USER_ROLE_MUTATION
  })

  return get(response, 'data.admin.user.patch')
}
